import { PostingReportView } from "./PostingReportView";
import { FC } from "react";

export const PostingReportContainer: FC = () => {
  return <PostingReportView />;
};
